import { render, staticRenderFns } from "./AdditionalFieldForm.vue?vue&type=template&id=346bed17&"
import script from "./AdditionalFieldForm.vue?vue&type=script&lang=js&"
export * from "./AdditionalFieldForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports